import { useState } from 'react';
import { JIRA_HOSTS_TYPES } from './jira.oauth2.consts';
import JiraHostTypePicker from './JiraHostTypePicker';
import HostForm from './host-components/HostForm';

const JiraOAuth2Form = () => {
  const [hostType, setHostType] = useState(JIRA_HOSTS_TYPES.CLOUD);

  return (
    <div className='flex flex-col items-start'>
      <div className='text-muted-foreground text-sm'>
        Select which option applies:
      </div>
      <JiraHostTypePicker value={hostType} onChange={setHostType} />
      <HostForm hostType={hostType} />
    </div>
  );
};

export default JiraOAuth2Form;
